import React, { useState } from 'react';

const LandingAccordion = ({ items, idPrefix, itemClassName = '', defaultOpen = 0 }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpen);

  return (
    <div className="lp-accordion">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const panelId = `${idPrefix}-panel-${index}`;
        const buttonId = `${idPrefix}-button-${index}`;
        return (
          <div key={item.question} className={`lp-faq-item ${itemClassName}${isOpen ? ' is-open' : ''}`}>
            <h3>
              <button
                id={buttonId}
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
              >
                {item.question}
                <span className="lp-faq-toggle" aria-hidden="true" />
              </button>
            </h3>
            <div
              id={panelId}
              className="lp-faq-panel"
              role="region"
              aria-labelledby={buttonId}
              aria-hidden={!isOpen}
            >
              <div>
                <p>{item.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LandingAccordion;
